// src/firebaseConfig.js

// 1. Importiamo gli strumenti che ci servono
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// 2. La TUA configurazione
const firebaseConfig = {
  apiKey: "AIzaSyCh0ahXkS4wiDkombt1tyHqbAsYfwBKuYY",
  authDomain: "civic-webapp.firebaseapp.com",
  projectId: "civic-webapp",
  storageBucket: "civic-webapp.firebasestorage.app",
  messagingSenderId: "431454217436",
  appId: "1:431454217436:web:17d4e601a8da7014bb0019",
  measurementId: "G-3MQ7HVGRWB"
};

// 3. Inizializziamo l'app
const app = initializeApp(firebaseConfig);

// 4. ESPORTIAMO i servizi
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;